import { config, handleResponse } from '../../_helpers';

export const notificationServices = {
    CreateNotification,
    GetNotificationLogs,
    UpdateNotification,
    GetAllNotifications,
    CreateWaivedChargesLog,
    ClearNotifications,
    CreateSQNotification,
}

function CreateNotification(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WebPush/CreateDataMongo`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WebPush/CreateWebPush`, requestOptions).then(handleResponse);
}

function GetNotificationLogs(userId, roleId) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/WebPush/getDataMongo`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WebPush/getDataMongoByRoleId?roleId=${roleId}&userId=${userId}`, requestOptions).then(handleResponse);
}

// function UpdateNotification(payload, id) {
//     const requestOptions = {
//         method: 'PUT',
//         body: JSON.stringify(payload),
//         headers: {
//             "Content-type": "application/json; charset=UTF-8"
//         }
//     };
//     return fetch(`${config.apiUrl}/WebPush/putDataMongoId/${id}`, requestOptions).then(handleResponse);
// }
function UpdateNotification(isViewed, id) {
    const requestOptions = {
        method: 'PUT',
    };
    return fetch(`${config.apiUrl}/WebPush/updateIsViewed/${id}?isViewed=${isViewed}`, requestOptions).then(handleResponse);
}

function GetAllNotifications(userId, roleId, skip, take) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/WebPush/getAllDataMongo?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WebPush/getAllDataMongoByRoleId?roleId=${roleId}&userId=${userId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}
function CreateWaivedChargesLog(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WebPush/CreateWaivedChargesLog`, requestOptions).then(handleResponse);
}
function ClearNotifications(userId, roleId) {
    const requestOptions = {
        method: 'PUT',
        // body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WebPush/clearAll?userId=${userId}&roleId=${roleId}`, requestOptions).then(handleResponse);
}

function CreateSQNotification(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WebPush/CreateSQNotification`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WebPush/createSQnotificationWithSBM`, requestOptions).then(handleResponse);
}